import ARRepresentante from '../../views/representante/Index.vue';
import ARRMeusDados from '../../views/representante/MeusDados.vue';
import ARRRecebidas from '../../views/representante/Recebidas.vue';
import ARREnviadas from '../../views/representante/Enviadas.vue';
import ARRGanhas from '../../views/representante/Ganhas.vue';
import ARRCompletas from '../../views/representante/Completas.vue';
import ARRRejeitadasPU from '../../views/representante/RejeitadasPU.vue';
import ARRRejeitadasPL from '../../views/representante/RejeitadasPL.vue';
import ARRPerdidas from '../../views/representante/Perdidas.vue';
import ARRCotRecebida from '../../views/representante/CotacaoRecebida.vue';
import ARRCotEnviada from '../../views/representante/CotacaoEnviada.vue';
import ARRCotGanha from '../../views/representante/CotacaoGanha.vue';
import ARRCotCompleta from '../../views/representante/CotacaoCompleta.vue';
import ARRCotRejeitada from '../../views/representante/CotacaoRejeitada.vue';
import ARRCotPerdida from '../../views/representante/CotacaoPerdida.vue';

import UserTypes from '../../enums/UserTypes';

export default [
  {
    path: '/area-restrita/representate',
    name: 'representante',
    component: ARRepresentante,
    children: [
      {
        path: '/area-restrita/representante/meus-dados',
        name: 'representante-meus-dados',
        component: ARRMeusDados,
        meta: { userType: UserTypes.REPRESENTATIVE },
      },
      {
        path: '/area-restrita/representante/recebidas/',
        name: 'representante-recebidas',
        component: ARRRecebidas,
        meta: { userType: UserTypes.REPRESENTATIVE },
      },
      {
        path: '/area-restrita/representante/enviadas/',
        name: 'representante-enviadas',
        component: ARREnviadas,
        meta: { userType: UserTypes.REPRESENTATIVE },
      },
      {
        path: '/area-restrita/representante/ganhas/',
        name: 'representante-ganhas',
        component: ARRGanhas,
        meta: { userType: UserTypes.REPRESENTATIVE },
      },
      {
        path: '/area-restrita/representante/completas/',
        name: 'representante-completas',
        component: ARRCompletas,
        meta: { userType: UserTypes.REPRESENTATIVE },
      },
      {
        path: '/area-restrita/representante/rejeitadas-por-usuario/',
        name: 'representante-rejeitadas-pelo-usuario',
        component: ARRRejeitadasPU,
        meta: { userType: UserTypes.REPRESENTATIVE },
      },
      {
        path: '/area-restrita/representante/rejeitadas-por-lojistas/',
        name: 'representante-rejeitadas-pelos-lojistas',
        component: ARRRejeitadasPL,
        meta: { userType: UserTypes.REPRESENTATIVE },
      },
      {
        path: '/area-restrita/representante/perdidas/',
        name: 'representante-perdidas',
        component: ARRPerdidas,
        meta: { userType: UserTypes.REPRESENTATIVE },
      },
      {
        path: '/area-restrita/representante/cotacao/recebida/:id',
        name: 'representante-cotacao-recebida',
        props: true,
        component: ARRCotRecebida,
        meta: { userType: UserTypes.REPRESENTATIVE },
      },
      {
        path: '/area-restrita/representante/cotacao/enviada/:id',
        name: 'representante-cotacao-enviada',
        props: true,
        component: ARRCotEnviada,
        meta: { userType: UserTypes.REPRESENTATIVE },
      },
      {
        path: '/area-restrita/representante/cotacao/ganha/:id',
        name: 'representante-cotacao-ganha',
        props: true,
        component: ARRCotGanha,
        meta: { userType: UserTypes.REPRESENTATIVE },
      },
      {
        path: '/area-restrita/representante/cotacao/completa/:id',
        name: 'representante-cotacao-completa',
        props: true,
        component: ARRCotCompleta,
        meta: { userType: UserTypes.REPRESENTATIVE },
      },
      {
        path: '/area-restrita/representante/cotacao/rejeitada/:cot_id/:usu_id/:tipo',
        name: 'representante-cotacao-rejeitada',
        props: true,
        component: ARRCotRejeitada,
        meta: { userType: UserTypes.REPRESENTATIVE },
      },
      {
        path: '/area-restrita/representante/cotacao/perdida/:cot_id/:usu_id',
        name: 'representante-cotacao-perdida',
        props: true,
        component: ARRCotPerdida,
        meta: { userType: UserTypes.REPRESENTATIVE },
      },
    ],
  },
];
